import React, { useEffect, useState } from "react";
import { Field, reduxForm, getFormValues, change } from "redux-form";
import { required } from "redux-form-validators";
import { connect } from "react-redux";
import moment from "moment";
import SelectBox from "../../../Components/Forms/selectbox";
import DateTimeInput from "../../../Components/Forms/datetime";
import AutosugformApi from "../../../Components/Forms/autocompleteapi";
import switcbutton from "../../../Components/Forms/switch";

const BedrijvenForm = ({ handleSubmit, standplaatsen, formValues, OpenmMdal, accommodaties, gast, dispatch, bedrijf }) => {
  const [keuze, setKeuze] = useState("accommodatie");
  useEffect(() => {
    if (gast) {
      dispatch(change("gastenverbuikedit", "gast", gast));
    }

    if (formValues?.keuze) {
      setKeuze(formValues.keuze);
    } else if (!formValues?.keuze) {
      if (bedrijf.modules.includes("kampeerplaatsen")) {
        dispatch(change("gastenverbuikedit", "keuze", "kampeerplaats"));
        setKeuze("kampeerplaats");
      } else if (bedrijf.modules.includes("accommodaties")) {
        dispatch(change("gastenverbuikedit", "keuze", "accommodatie"));
        setKeuze("accommodatie");
      }
    }
  }, [gast, formValues?.keuze, bedrijf.modules, dispatch]);
  return (
    <div className="box box-default">
      <form onSubmit={handleSubmit}>
        <div className="box-body">
          <div className="row">
            <div className="col-6">
              <Field name="gast" type="email" minval="3" suggestievalue="email" suggestieid="_id" url="/api/admin/stamgegevens/find" validate={required({ msg: "Dit item is verplicht" })} component={AutosugformApi} label="Zoek op gast e-mail" />
            </div>
          </div>

          <div className="row">
            <div className="col-6">
              <Field name="altijdtoegang" label="De gast heeft altijd toegang" type="input" component={switcbutton} />
              <Field name="aankomst" component={DateTimeInput} type="input" validate={required({ msg: "Dit item is verplicht" })} label="Aankomst datum verblijf" />
              <Field name="vertrek" component={DateTimeInput} type="input" validate={required({ msg: "Dit item is verplicht" })} label="Vertrek datum verblijf" />
            </div>
          </div>
        </div>
        <div className="pull-left submit">
          <input type="submit" className="btn btn-next btn-fill btn-success btn-wd btn-mg" name="next" value="Opslaan" />
        </div>
      </form>
    </div>
  );
};

const mapStateToProps = (state) => ({
  formValues: getFormValues("gastenverbuikedit")(state), // get current form values
  initialValues: state.gastenverbruik.gastverbruik, // pull initial values from account reducer
});

export default connect(mapStateToProps)(
  reduxForm({
    form: "gastenverbuikedit",
  })(BedrijvenForm)
);
